module.exports = __webpack_public_path__ + "static/teamleader-25129a53d33e7c426de8613474350f72.svg";